// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"secondary-codes-module__searchWrapper___3FYHB"};